import type { SVGProps } from 'react'
const LineBriefcase = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M19.25 6.5H16v-.75A2.755 2.755 0 0 0 13.25 3h-2.5A2.755 2.755 0 0 0 8 5.75v.75H4.75A2.755 2.755 0 0 0 2 9.25v9A2.755 2.755 0 0 0 4.75 21h14.5A2.755 2.755 0 0 0 22 18.25v-9a2.755 2.755 0 0 0-2.75-2.75M9.5 5.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v.75h-5zM4.75 8h14.5c.69 0 1.25.56 1.25 1.25v.69l-2.56 2.56H6.06L3.5 9.94v-.69C3.5 8.56 4.06 8 4.75 8m14.5 11.5H4.75c-.69 0-1.25-.56-1.25-1.25v-6.19L5.44 14H7v1.5h1.5V14h7v1.5H17V14h1.56l1.94-1.94v6.19c0 .69-.56 1.25-1.25 1.25"
		/>
	</svg>
)
export { LineBriefcase }
